const toneClasses = {
  green: "bg-secondary_1 text-secondary",
  orange: "bg-primary_1 text-primary",
  amber: "bg-amber-50 text-amber-600",
  gray: "bg-gray-100 text-gray-400",
};

export default function SectionIcon({ icon: Icon, tone = "green", size = "md" }) {
  const box = size === "sm" ? "h-8 w-8 rounded-lg" : "h-9 w-9 rounded-xl";
  return (
    <span className={`flex shrink-0 items-center justify-center ${box} ${toneClasses[tone] || toneClasses.green}`} aria-hidden="true">
      <Icon size={size === "sm" ? 15 : 17} />
    </span>
  );
}
